import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="accordion"
export default class extends Controller {
  static targets = ["content", "header"];
  static values = { assignmentId: Number };

  connect() {
    const savedMissionId = localStorage.getItem(this.storageKey);
    if (!savedMissionId) return;

    const header = this.headerTargets.find(
      (h) => h.dataset.missionId === savedMissionId
    );
    if (header) this.openAccordion(header);
  }

  toggle(event) {
    const header = event.currentTarget;
    const content = header.nextElementSibling;

    if (content.classList.contains("open")) {
      this.closeAccordion(header);
      localStorage.removeItem(this.storageKey);
    } else {
      this.closeAll();
      this.openAccordion(header);
      localStorage.setItem(this.storageKey, header.dataset.missionId);
    }
  }

  closeAll() {
    this.headerTargets.forEach((header) => this.closeAccordion(header));
  }

  openAccordion(header) {
    const content = header.nextElementSibling;
    header.classList.add("active");
    content.classList.add("open");
    content.style.maxHeight = content.scrollHeight + "px";
  }

  closeAccordion(header) {
    const content = header.nextElementSibling;
    header.classList.remove("active");
    content.classList.remove("open");
    content.style.maxHeight = null;
  }

  get storageKey() {
    return `accordion_assignment_${this.assignmentIdValue}`;
  }
}
